import { default as ReactSelect, components } from "react-select";
import {
  disabled as disabledClass,
  marginBottom,
  select,
  selectWrapper,
} from "../../components/Select.module.scss";
import { errorBorder, errorsBox } from "./shared.module.scss";
import { ValidationErrors } from "./ValidationErrors";
import cn from "classnames";
import { controlTypes } from "../../constants/voice";
import sharedStyles from "../../shared.module.scss";
import styles from "./TypeSelect.module.scss";
import { useFormatMessage } from "../../i18n";

export function TypeSelect({
  controls = [],
  formik,
  findFirstControlOfType,
  disabled,
  pristine,
  errors = [],
}) {
  const tr = useFormatMessage();

  const typeOptions = [
    { value: "0", label: "switch", icon: controlTypes[0], type: "switch" },
    {
      value: "1",
      label: "light",
      icon: controlTypes[1],
      type: "noRegLight",
    },
    {
      value: "2",
      label: "dimmer",
      icon: controlTypes[2],
      type: "regLight",
    },
    { value: "3", label: "rgb_light", icon: controlTypes[3], type: "rgbLight" },
    {
      value: "4",
      label: "temperature_sensor",
      icon: controlTypes[4],
      type: "tempIndicator",
    },
    {
      value: "5",
      label: "thermostat",
      icon: controlTypes[5],
      type: "thermostat",
    },
    { value: "6", label: "blind", icon: controlTypes[6], type: "blinds" },
    {
      value: "7",
      label: "scene_trigger",
      icon: controlTypes[7],
      type: "scene",
    },
  ];

  // All possible types from non-configured controls
  const possibleTypes = controls
    .map((control) => {
      return control.possible_types;
    })
    .flat();

  // Type options filtered by possible types
  const availableTypesOptions = typeOptions.filter((option) =>
    possibleTypes.includes(parseInt(option.value))
  );

  const noOptionsAvailable = !availableTypesOptions.length;

  const { Option, SingleValue } = components;

  // Modified react-select component Option
  const OptionWithIcon = (props) => (
    <Option {...props}>
      <img
        src={props.data.icon}
        className={styles.typeIcon}
        alt={props.data.type}
      />
      {tr(props.data.label)}
    </Option>
  );

  // Modified react-select component SingleValue
  const SingleValueWithIcon = (props) => (
    <SingleValue {...props}>
      <img
        src={props.data.icon}
        className={styles.typeIcon}
        alt={props.data.type}
      />
      {tr(props.data.label)}
    </SingleValue>
  );

  const showErrors = !pristine && errors.length !== 0;

  const placeHolder = noOptionsAvailable
    ? "no_types_available"
    : "select_control_type";

  return (
    <>
      <div
        className={cn(
          selectWrapper,
          marginBottom,
          (disabled || noOptionsAvailable) && disabledClass
        )}
      >
        <ReactSelect
          className={cn(
            sharedStyles.formText,
            styles.select,
            select,
            showErrors && errorBorder
          )}
          classNames={{
            control: () => styles.control,
            menuList: () => styles.menuList,
            option: () => styles.option,
            singleValue: () => styles.singleValue,
            placeholder: () => styles.placeHolder,
          }}
          components={{
            Option: OptionWithIcon,
            SingleValue: SingleValueWithIcon,
            DropdownIndicator: null,
          }}
          defaultValue={availableTypesOptions.find(
            ({ value }) => value === formik.values.type
          )}
          hideSelectedOptions
          isDisabled={disabled || noOptionsAvailable}
          isSearchable={false}
          name="type"
          onChange={(option) => {
            formik.setFieldValue("type", option.value);
            formik.setFieldValue(
              "control",
              findFirstControlOfType(option.value)
            );
          }}
          options={availableTypesOptions}
          placeholder={tr(placeHolder)}
          unstyled
          value={availableTypesOptions.find(
            ({ value }) => value === formik.values.type
          )}
        />
      </div>
      {!pristine && (
        <div className={cn(showErrors && errorsBox)}>
          <ValidationErrors errors={errors} />
        </div>
      )}
    </>
  );
}
